<template>
  <div class="form-group sf-input-wrapper">
    <label v-if="label" :for="name" class="col-form-label">
      {{ label }}
      <span v-if="required" class="required">*</span>
    </label>
    <div :class="{ 'sf-input-field--has-icon': icon }" class="sf-input-field">
      <i v-if="icon" :class="icon" class="sf-input-icon"></i>
      <input :id="name"
             :class="inputClass"
             :disabled="disabled"
             :max="max"
             :min="min"
             :name="name"
             :placeholder="placeholder"
             :required="required"
             :type="type"
             :value="value"
             @blur="$emit('blur', $event)"
             @focus="$emit('focus', $event)"
             @input="$emit('input', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SfInput",
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    inputClass: {
      type: String,
      default: "form-control",
    },
    min: {
      type: [String, Number],
      default: undefined,
    },
    max: {
      type: [String, Number],
      default: undefined,
    },
  },
};
</script>

<style scoped>
.required {
  color: red;
}

.col-form-label {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #333 !important;
}
</style>

<style>
/* Input border kaybolmaması için global style */
.sf-input-wrapper input.form-control {
  border: 1px solid #e0e0e0 !important;
  outline: 0;
  box-shadow: none !important;
  height: 48px;
  font-size: 16px;
  border-radius: 10px;
}

.sf-input-wrapper input.form-control:focus,
.sf-input-wrapper input.form-control:active,
.sf-input-wrapper input.form-control:hover {
  border: 1px solid #e0e0e0 !important;
  outline: 0;
  box-shadow: none !important;
}

.sf-input-wrapper input.form-control::placeholder {
  color: #9aa0a6;
}

/* Icon support */
.sf-input-field {
  position: relative;
}

.sf-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 18px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.sf-input-field--has-icon input.form-control {
  padding-left: 42px !important;
}
</style>
